module.exports = __webpack_public_path__ + "img/404.a0e09717.png";